module.exports = __webpack_public_path__ + "img/043-haggler.a8160147.png";